<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { mloc } from "module/utils";
  import { documentIcons } from "module/foundryDocuments";
  import { enabledPacks } from "module/store/IndexingDisabledStore";
  import {
    type SearchFilterConfig,
    FILTER_COMPENDIUM_ALL,
  } from "module/store/Filters";

  import FilterModal from "./FilterModal.svelte";
  import FilterOptionSausage from "./FilterOptionSausage.svelte";

  const dispatch = createEventDispatcher();

  let { open = false, config }: { open?: boolean; config: SearchFilterConfig } =
    $props();

  // Input filters
  let packFilter = $state("");

  let allSelected = $derived(config?.compendiums[0] === FILTER_COMPENDIUM_ALL);
  let packs = $derived(
    $enabledPacks.map((pack) => ({
      id: pack.collection,
      title: pack.title,
      selected: Boolean(config?.compendiums?.includes(pack.collection)),
      type: pack.documentName,
      icon: documentIcons[pack.documentName],
    }))
  );

  let baseTypes = $derived(
    new Set(config.documentTypes.map((type) => type.split(":")[0]))
  );

  let filterTypes = $derived(Boolean(baseTypes.size));

  const filterItems = (filter: string, items: typeof packs) => {
    return items.filter(
      (item) =>
        (!filterTypes || baseTypes.has(item.type)) &&
        item.title.toLowerCase().includes(filter.toLowerCase())
    );
  };

  function toggleAll() {
    if (!allSelected) {
      dispatch("change", { compendiums: [FILTER_COMPENDIUM_ALL] });
    } else {
      dispatch("change", { compendiums: [] });
    }
  }

  function selectPack(id: string) {
    let updated = new Set(config.compendiums);
    if (allSelected) {
      updated = new Set([id]);
    } else if (config.compendiums.includes(id)) {
      updated.delete(id);
    } else {
      updated.add(id);
    }
    dispatch("change", { compendiums: Array.from(updated) });
  }

  function clear() {
    dispatch("change", { compendiums: [] });
  }
</script>

<FilterModal
  title={mloc("FilterEditorCompendiumSelectTitle")}
  {open}
  on:close
  on:clear={clear}
>
  <div class="filter-input">
    <input
      type="text"
      placeholder={mloc("FilterEditorOptionFilter")}
      class="option-filter"
      bind:value={packFilter}
    />
    <i
      class="fas fa-xmark clear {packFilter ? '' : 'hide-clear'}"
      title={mloc("FilterEditorOptionFilterClear")}
      on:click={() => (packFilter = "")}
    ></i>
  </div>
  <ul>
    <FilterOptionSausage
      selected={config?.compendiums[0] === FILTER_COMPENDIUM_ALL}
      title={mloc("FilterEditorCompendiumAll")}
      square
      on:click={toggleAll}
    />
    {#each filterItems(packFilter, packs) as pack (pack.id)}
      <FilterOptionSausage
        selected={allSelected || pack.selected}
        title={pack.title}
        icon={pack.icon}
        square
        on:click={() => selectPack(pack.id)}
      />
    {/each}
  </ul>
</FilterModal>

<style>
  ul {
    overflow: auto;
    padding: 0;
    flex-grow: 1;
    margin: 0;
  }

  .filter-input {
    display: flex;
    align-items: center;
    position: relative;
  }

  .clear {
    position: absolute;
    right: 0;
    padding: 0 0.5em;
    height: 100%;
    display: flex;
    align-items: center;
  }
  .hide-clear {
    opacity: 0;
  }
  .option-filter {
    border-radius: 0 !important;
    border: none !important;
    border-radius: 0 !important;
    padding: 0 0.6em !important;
    flex-grow: 1;
    color: var(--color-light-2) !important;
  }
  .option-filter::placeholder {
    color: var(--color-light-2);
    opacity: 0.6;
  }

  .option-filter:focus {
    box-shadow: rgba(0, 0, 0, 0.25) 0px 0px 0px 2px inset;
  }

  ul :global(li:not(:first-child)) {
    margin-left: 10px;
  }
</style>
